import React from 'react';
import '../../assets/css/needmoresupport.css';
import {checkUrlPath} from './CommonFunctions';

export default class NeedMoreSupport extends React.Component {

    NeedMoreSupportcallBack(solutionItem) {
        if(solutionItem.sclinktrackid !== null && solutionItem.sclinktrackid !== undefined) {
            //window.scLinkTrackID(solutionItem.sclinktrackid);
        }
    }

    render() {
        if (this.props.Data.needmoresupport !== undefined && this.props.Data.needmoresupport[0].nmsList.length > 0) {
            return(
                <section className="main large-mw-none  w_wayfinder" role="region">
                    <div className="row">
                        <div className="column tiny-12">
                            <h2 className="wayfinder-header text-white"> { this.props.Data.needmoresupport[0].needmoretitle }  </h2>
                            <ul className="wayfinder-ul">
                            {
                                this.props.Data.needmoresupport[0].nmsList.map((item, index) => {
                                    return <li key={"list-" + index}>
                                                <div className="wayfinder-list-item">
                                                        <div className="display-table medium-padding-top-tiny small-padding-top-zero">
                                                            <div className="wayfinder-link">
                                                                <a className="button cta-text outage-cta-text" href={checkUrlPath(item.linkUrl)} onClick={() => this.NeedMoreSupportcallBack(item)} role="button" tabIndex="0" data-track={item.linkText} target={item.checkBox ? "_blank" : "" }> { item.linkText} </a>
                                                            </div>
                                                        </div>      
                                                </div>
                                            </li>
                                })
                            }
                            </ul>
                        </div>
                    </div>
                </section>
            )
        } else {
            return null
        }

    }
}





// WEBPACK FOOTER //
// ./src/components/modules/NeedMoreSupport.js